'use client'

import { useState } from 'react'
import Link from 'next/link'
import { useSession, signOut } from 'next-auth/react'

export default function LandingPage() {
  const [menuOpen, setMenuOpen] = useState(false)
  const { data: session } = useSession()

  return (
    <main
      style={{
        minHeight: '100vh',
        backgroundImage:
          'linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.35)), url("/images/River_and_Bridge.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        color: '#ffffff',
      }}
    >
      <header
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '1.5rem',
          position: 'relative',
        }}
      >
        <button
          onClick={() => setMenuOpen((open) => !open)}
          style={{
            width: '52px',
            height: '52px',
            borderRadius: '999px',
            border: '1px solid rgba(255,255,255,0.35)',
            background: 'rgba(0,0,0,0.35)',
            color: '#fff',
            fontSize: '1.5rem',
            cursor: 'pointer',
          }}
        >
          ☰
        </button>

        {menuOpen && (
<nav
  style={{
    position: 'absolute',
    top: '5.5rem',
    right: '1.5rem',
    background: 'rgba(20,20,20,0.92)',
    borderRadius: '12px',
    padding: '0.5rem',
    display: 'grid',
    gap: '0.25rem',
  }}
>
  <Link
    href="/"
    style={{
      color: '#ffffff',
      textDecoration: 'none',
      padding: '0.75rem 0.9rem',
      borderRadius: '8px',
      display: 'block',
    }}
  >
    Welcome
  </Link>

  {!session && (
    <Link
      href="/login"
      style={{
        color: '#ffffff',
        textDecoration: 'none',
        padding: '0.75rem 0.9rem',
        borderRadius: '8px',
        display: 'block',
      }}
    >
      Log In
    </Link>
  )}

  {session && (
    <>
      <Link
        href="/home"
        style={{
          color: '#ffffff',
          textDecoration: 'none',
          padding: '0.75rem 0.9rem',
          borderRadius: '8px',
          display: 'block',
        }}
      >
        Home
      </Link>

      <button
        onClick={() => signOut()}
        style={{
          background: 'none',
          border: 'none',
          color: '#ffffff',
          textAlign: 'left',
          padding: '0.75rem 0.9rem',
          borderRadius: '8px',
          cursor: 'pointer',
        }}
      >
        Log Out
      </button>
    </>
  )}
</nav>
        )}
      </header>

<section
  style={{
    minHeight: 'calc(100vh - 84px)',
    display: 'grid',
    alignItems: 'center',
    padding: '2rem',
  }}
>
  <div
    style={{
      maxWidth: '760px',
      padding: '2rem',
      background: 'rgba(0,0,0,0.28)',
      borderRadius: '16px',
      backdropFilter: 'blur(3px)',
    }}
  >
    <p
      style={{
        margin: 0,
        fontSize: '0.95rem',
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
      }}
    >
      Welcome To
    </p>

    <h1
      style={{
        marginTop: '0.75rem',
        marginBottom: '1rem',
        fontSize: 'clamp(2.5rem, 6vw, 4.75rem)',
        lineHeight: 1.05,
      }}
    >
      Matabanic Lodge
    </h1>

    <p
      style={{
        margin: 0,
        fontSize: '1.1rem',
        lineHeight: 1.7,
        maxWidth: '640px',
      }}
    >
      A private place for members, fellowship, and lodge information.
    </p>
  </div>
</section>
    </main>
  )
}
